import { MembershipType } from "./types.js";
/**
 * Features a customer below the root doesn't inherit from the root's private config: only the
 * root itself and the organizations below it get them.
 */
export const NOT_INHERITED_BY_CUSTOMERS = [
    "allowAdminPrivileges",
    "allowServiceAndRepairDownload",
];
/** A customer somewhere below the root of its tree. */
export function isManagedCustomer(entity) {
    return (entity.ancestors?.length ?? 0) > 0 && entity.type !== MembershipType.Organization;
}
/** The features without the ones customers don't inherit, for viewers outside the tree. */
export function withoutNotInheritedFeatures(features) {
    const filtered = { ...features };
    for (const key of NOT_INHERITED_BY_CUSTOMERS)
        delete filtered[key];
    return filtered;
}
/**
 * The root's features as the given entity sees them. Decide this from the entity document, not
 * from the session claims: claims are set at sign-in and go stale when the entity changes.
 * Without an entity (staff) the features are returned unchanged.
 */
export function featuresForEntity(features, entity) {
    if (!entity || !isManagedCustomer(entity))
        return features;
    return withoutNotInheritedFeatures(features);
}
//# sourceMappingURL=entityFeatures.js.map